const constants = {
  nonStickyModules: [
    'shop-canada-compare-cards',
    'shop-canada-hub',
    'shop-japan-compare-cards',
    'shop-mexico-compare-cards',
    'shop-mexico-hub',
    'international-shop-product-details-mexico',
  ],
  UPLIFT_MX: {
    SERVICE_CARDS: ['the-platinum-card', 'platinum-business-card-american-express'],
  },
};

export default constants;
